import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorBannerProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export default function ErrorBanner({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  onRetry,
}: ErrorBannerProps) {
  return (
    <div className="rounded-xl border border-rose-200/60 bg-rose-50 p-4 dark:border-rose-900/40 dark:bg-rose-950/20">
      <div className="flex items-start gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-rose-100 dark:bg-rose-900/40">
          <AlertTriangle className="h-4 w-4 text-rose-500" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-rose-800 dark:text-rose-200">{title}</h3>
          <p className="mt-0.5 text-sm text-rose-600 dark:text-rose-300">{message}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-rose-100 px-3 py-1.5 text-xs font-medium text-rose-700 transition-colors hover:bg-rose-200 dark:bg-rose-900/40 dark:text-rose-300 dark:hover:bg-rose-800/40"
            >
              <RefreshCw className="h-3 w-3" />
              Retry
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
